export default __webpack_public_path__ + "static/media/ic_btc_40.1560513c.svg";